var modules_11bc8044 = {"text":"NotFound_module_text__eeb7b5b5"};
import "../../../assets/esm/components/Table/src/NotFound~HLNhVJ1-.css";

export { modules_11bc8044 as default };
//# sourceMappingURL=NotFound.module.less.js.map
